import {
    getReportConfigurationMember,
    searchReportConfigurationMembers,
} from "../../../../service/httpsCalls";
import type { ReportConfigurationMemberSearchResult } from "../types";

export const searchMembers = (text: string, memberDob: string) =>
    searchReportConfigurationMembers(text, memberDob) as Promise<ReportConfigurationMemberSearchResult[]>;

export const loadMember = (memberIdEncoded: string) =>
    getReportConfigurationMember(memberIdEncoded) as Promise<ReportConfigurationMemberSearchResult>;
